import React from 'react';
import '../styles.css';

interface MenuPausedProps {
  shopName?: string;
  logoUrl?: string;
}

const MenuPaused: React.FC<MenuPausedProps> = ({ shopName, logoUrl }) => (
  <div className="menu-paused" style={{
    minHeight: '100vh', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', textAlign: 'center',
    gap: '16px', padding: '24px',
    background: 'var(--color-background)', color: 'var(--color-text)',
  }}>
    {logoUrl && <img src={logoUrl} alt="" style={{ width: 96, height: 96, borderRadius: 16, objectFit: 'cover' }} />}
    {shopName && <h1 style={{ fontFamily: 'var(--font-display, serif)', margin: 0 }}>{shopName}</h1>}
    <p style={{ maxWidth: 420, lineHeight: 1.5 }}>
      Το μενού είναι προσωρινά μη διαθέσιμο. / This menu is temporarily unavailable.
      <br />Παρακαλούμε επικοινωνήστε με το κατάστημα.
    </p>
  </div>
);

export default MenuPaused;
